﻿export const urlIdentity = {
    login: '/login',

    api: {
        login: '/api/identity/login',
        verifyToken: '/api/identity/verifytoken',
        forgotUsername: '/api/identity/forgotusername',
        forgotPassword: '/api/identity/forgotpassword',
        resetPassword: '/api/identity/resetpassword',
        register: '/api/identity/register',
        registerWithPassword: '/api/identity/registerwithpassword',
        confirmPassword: '/api/identity/confirmpassword'
    }
};

export const url = {
    dashboard: '/sys',
    profile: '/profile',
    profileCredential: '/profile#credential',
    profileSecurity: '/profile#security',
    query: '/sys/query',
    userManager: '/sys/user/manager',
    userManage: '/sys/user/manage/{userId}',
    jobQueue: '/sys/job',
    programDirector: '/sys/programdirector/manage/{userId}',
    student: '/sys/student/',
    collegeCreate: '/sys/college/create',
    dataAuditTicket: '/sys/dataauditticket/',
    scholarshipCreate: '/sys/scholarship/create',
    highSchoolManager: '/sys/highschool/manager',
    highSchoolCreate: '/sys/highschool/create',
    fundingRequest: (encodedScholarshipAwardedId) => { return '/sys/scholar/fundingrequest/' + encodedScholarshipAwardedId },
    fundingRequestHistorical: '/sys/scholar/fundingrequesthistorical',
    fundingRequestManager: (encodedFundingRequestId) => { return '/sys/scholar/fundingrequestmanager/' + encodedFundingRequestId; },
    scholar: (encodedScholarId) => { return '/sys/scholar/' + encodedScholarId; },
    importer: '/sys/tool/importer',
    fileRepository: '/sys/filerepo',
    videoEagleScout: '/sys/video/eaglescout',

    api: {
        dashboardInit: '/api/dashboard/init',
        dashboardWidgetInit: '/api/dashboard/widgetinit',

        //profile
        profileInit: '/api/identity/profileinit',
        profile: '/api/identity/profile',
        profileSecurity: '/api/identity/profilesecurity',
        profileEmailConfirm: '/api/identity/emailconfirm',
        profileEmailConfirmResend: '/api/identity/emailconfirmresend',
        profileChangeEmail: '/api/identity/changeemail',
        profileChangeUsername: '/api/identity/changeusername',
        profileChangePassword: '/api/identity/changepassword',
        profileEnable2FA: '/api/identity/enable2fa',
        profileDisable2FA: '/api/identity/disable2fa',

        //user
        userManagerSearch: '/api/user/search',
        userManagerFilter: '/api/user/filter',
        userManageInit: '/api/user/manageinit',
        userManageSave: '/api/user/save',
        userConfirmPasswordNotification: '/api/user/confirmpasswordnotification',
        userConfirmEmailNotification: '/api/user/confirmemailnotification',
        userForgotPasswordNotification: '/api/user/forgotpasswordnotification',
        userDisable2fa: '/api/user/disable2fa',
        userLockToggle: '/api/user/locktoggle',
        userRoleDefault: '/api/user/roledefault',

        //query
        queryInit: '/api/query/init',
        queryQuery: '/api/query/query',
        queryExport: '/api/query/export',
        querySaveView: '/api/query/saveview',
        queryDeleteView: '/api/query/deleteview',

        //job
        jobInit: '/api/job/init',
        jobActivity: '/api/job/activity',
        jobHistory: '/api/job/history',
        jobOutput: '/api/job/output',
        jobDownload: '/api/job/download',

        //lookup
        lookupGet: '/api/lookup/get',
        lookupGetAll: '/api/lookup/getall',
        lookupDelete: '/api/lookup/delete',

        //tag
        tagGet: '/api/tag/get',
        tagSave: '/api/tag/save',
        tagDelete: '/api/tag/delete',

        //college
        collegeManagerInit: '/api/college/managerinit',
        collegeManager: '/api/college/manager',
        collegeInit: '/api/college/collegeinit',
        collegeSave: '/api/college/collegesave',
        collegeDelete: '/api/college/collegedelete',

        //data audit ticket
        dataAuditTicketManagerInit: '/api/dataauditticket/managerinit',
        dataAuditTicketManagerRefresh: '/api/dataauditticket/managerrefresh',
        dataAuditTicketIgnore: '/api/dataauditticket/ignore',

        //scholarship
        scholarshipManagerInit: '/api/scholarship/managerinit',
        scholarshipManager: '/api/scholarship/manager',
        scholarshipInit: '/api/scholarship/scholarshipinit',
        scholarshipSave: '/api/scholarship/scholarshipsave',
        scholarshipDelete: '/api/scholarship/scholarshipdelete',

        //highschool
        highSchoolManagerInit: '/api/highschool/managerinit',
        highSchoolManager: '/api/highschool/manager',
        highSchoolInit: '/api/highschool/highschoolinit',
        highSchoolSave: '/api/highschool/highschoolsave',
        highSchoolDelete: '/api/highschool/highschooldelete',

        //address
        addressInit: '/api/address/addressinit',
        addressSave: '/api/address/addresssave',
        addressDelete: '/api/address/addressdelete',

        //program director
        programDirectorInit: '/api/programdirector/init',
        //programDirectorSave: '/api/programdirector/save',
        programDirectorAddressSave: '/api/programdirector/addresssave',
        programDirectorCollegeSave: '/api/programdirector/collegesave',
        programDirectorCollegeDelete: '/api/programdirector/collegedelete',

        //scholar
        scholarInit: '/api/scholar/init',
        scholarSave: '/api/scholar/save',
        scholarPhotoSave: '/api/scholar/photosave',
        scholarPhotoReset: '/api/scholar/photoreset',
        scholarHighSchoolSave: '/api/scholar/highschoolsave',
        scholarAddressSave: '/api/scholar/addresssave',
        scholarAddressTagSave: '/api/scholar/addresstagsave',
        scholarAddressDelete: '/api/scholar/addressdelete',
        scholarScholarshipAwardedSave: '/api/scholar/scholarshipawardedsave',
        scholarScholarshipAwardedDelete: '/api/scholar/scholarshipawardeddelete',
        scholarEnrollmentScholarshipInit: '/api/scholar/enrollmentscholarshipinit',
        scholarEnrollmentSave: '/api/scholar/enrollmentsave',
        scholarEnrollmentDelete: '/api/scholar/enrollmentdelete',
        scholarAcademicProgramSave: '/api/scholar/academicprogramsave',
        scholarAcademicProgramDelete: '/api/scholar/academicprogramdelete',
        scholarGraduationDetailSave: '/api/scholar/graduationdetailsave',
        scholarGraduationDetailDelete: '/api/scholar/graduationdetaildelete',
        scholarEnrichmentSave: '/api/scholar/enrichmentsave',
        scholarEnrichmentDelete: '/api/scholar/enrichmentdelete',
        scholarInternshipSave: '/api/scholar/internshipsave',
        scholarInternshipDelete: '/api/scholar/internshipdelete',
        scholarContinuingEducationSave: '/api/scholar/continuingeducationsave',
        scholarContinuingEducationDelete: '/api/scholar/continuingeducationdelete',
        scholarEmploymentSave: '/api/scholar/employmentsave',
        scholarEmploymentDelete: '/api/scholar/employmentdelete',
        scholarBusinessSave: '/api/scholar/businesssave',
        scholarBusinessDelete: '/api/scholar/businessdelete',
        scholarNoteSave: '/api/scholar/notesave',
        scholarNoteDelete: '/api/scholar/notedelete',
        scholarFundingRequestInit: '/api/scholar/fundingrequestinit',
        scholarFundingRequestSave: '/api/scholar/fundingrequestsave',
        scholarFundingRequestDelete: '/api/scholar/fundingrequestdelete',
        scholarFundingRequestManagerInit: '/api/scholar/fundingrequestmanagerinit',
        scholarFundingRequestManager: '/api/scholar/fundingrequestmanager',
        scholarFundingRequestProcessingSave: '/api/scholar/fundingrequestprocessingsave',
        scholarFundingRequestHistoricalInit: '/api/scholar/fundingrequesthistoricalinit',
        scholarFundingRequestHistorical: '/api/scholar/fundingrequesthistorical',
        scholarNewInit: '/api/scholar/newinit',
        scholarNewSave: '/api/scholar/newsave',

        //importer
        importerInit: '/api/importer/init',
        importerRecent: '/api/importer/recent',
        importerScholarCurrent: '/api/importer/scholarcurrent',
        importerScholarEnrichment: '/api/importer/scholarenrichment',
        importerScholarInternship: '/api/importer/scholarinternship',
        importerScholarGraduation: '/api/importer/scholargraduation',
        importerScholarAlumni: '/api/importer/scholaralumni',

        //eaglescoutapp
        eagleScoutAppSignup: '/api/eaglescoutapp/signup',
        eagleScoutAppResend: '/api/eaglescoutapp/resend',
        eagleScoutAppConfirm: '/api/eaglescoutapp/confirm',
        eagleScoutAppInit: '/api/eaglescoutapp/init',
        eagleScoutAppSave: '/api/eaglescoutapp/save',
        eagleScoutAppAwardInit: '/api/eaglescoutapp/awardinit',
        eagleScoutAppAward: '/api/eaglescoutapp/award',
        eagleScoutAppUserInit: '/api/eaglescoutapp/userinit',
        eagleScoutAppUser: '/api/eaglescoutapp/user',

        //eaglescout
        eagleScoutProcessingInit: '/api/eaglescout/processinginit',
        eagleScoutProcessingRevert: '/api/eaglescout/processingrevert',
        eagleScoutProcessingSave: '/api/eaglescout/processingsave',
        eagleScoutProcessingNotification: '/api/eaglescout/processingnotification',
        eagleScoutActivityLog: '/api/eaglescout/activitylog',
        eagleScoutInit: '/api/eaglescout/init',
        eagleScoutSave: '/api/eaglescout/save',

        //workflow
        workflowActivityLog: '/api/workflow/activitylog',

        workflowEagleScoutToScholarInit: '/api/workflow/eaglescouttoscholarinit',
        workflowEagleScoutToScholarSave: '/api/workflow/eaglescouttoscholarsave',
        workflowEagleScoutToScholarReset: '/api/workflow/eaglescouttoscholarreset',
        workflowEagleScoutToScholarProcessingSave: '/api/workflow/eaglescouttoscholarprocessingsave',
        workflowEagleScoutToScholarFinalizeInit: '/api/workflow/eaglescouttoscholarfinalizeinit',
        workflowEagleScoutToScholarFinalizeConvert: '/api/workflow/eaglescouttoscholarfinalizeconvert',
        workflowEagleScoutToScholarRevoke: '/api/workflow/eaglescouttoscholarrevoke',

        workflowCollegeReportInit: '/api/workflow/collegereportinit',
        workflowCollegeReportSave: '/api/workflow/collegereportsave',
        workflowCollegeReportReset: '/api/workflow/collegereportreset',
        workflowCollegeReportProcessingSave: '/api/workflow/collegereportprocessingsave',

        workflowCollegeReportAdditionalFileInit: '/api/workflow/collegereportadditionalfileinit',
        workflowCollegeReportAdditionalFileSave: '/api/workflow/collegereportadditionalfilesave',
        workflowCollegeReportAdditionalFileReset: '/api/workflow/collegereportadditionalfilereset',
        workflowCollegeReportAdditionalFileProcessingSave: '/api/workflow/collegereportadditionalfileprocessingsave',

        workflowAcceptanceLetterLiabilityReleaseInit: '/api/workflow/acceptanceletterliabilityreleaseinit',
        workflowAcceptanceLetterLiabilityReleaseSave: '/api/workflow/acceptanceletterliabilityreleasesave',
        workflowAcceptanceLetterLiabilityReleaseReset: '/api/workflow/acceptanceletterliabilityreleasereset',
        workflowAcceptanceLetterLiabilityReleaseProcessingSave: '/api/workflow/acceptanceletterliabilityreleaseprocessingsave',

        //file
        fileDownload: '/api/file/download',
        fileDownloadNamed: (name) => { return '/api/file/downloadnamed?name=' + name },
        videoNamed: (name) => { return '/api/file/video/' + name },

        //file: repository
        fileRepositoryInit: '/api/file/repositoryinit',
        fileRepositorySave: '/api/file/repositorysave',
        fileRepositoryDelete: '/api/file/repositorydelete',

        //file: create
        fileCreateInit: '/api/file/createinit',
        fileCreateSave: '/api/file/createsave',

        //report
        reportEducationProgramInit: '/api/report/educationprograminit',
        reportEducationProgram: '/api/report/educationprogram',
        reportScholarshipFundingInit: '/api/report/scholarshipfundinginit',
        reportScholarshipFunding: '/api/report/scholarshipfunding',

    },

    job: {
        export1: '/api/job/export1',
        importscholarmeta: '/api/job/importscholarmeta'
    }
};